import PhaseTimelineSlider from './PhaseTimelineSlider';

const mql = window.matchMedia('(min-width: 1090px)');

let componentStore = [];

function onMediaQueryChange(mq) {
  componentStore.forEach(component => component.deconstructor && component.deconstructor());
  componentStore = [];

  document
    .querySelectorAll('.phase-timeline')
    .forEach(($slider) => {
      if (!$slider.classList.contains('phase-timeline--minimal')) {
        componentStore.push(new PhaseTimelineSlider($slider, mq));
      }
    });
}

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
